var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 transition"},[_c('GenericReport',{attrs:{"title":_vm.title,"route":_vm.route,"fields":_vm.tableFields,"topFilters":_vm.topFilters,"sideFilters":_vm.sideFilters,"tipoRelatorio":"relatorioMateriais"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }